
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node/appeal",
      function () {
        return require("private-next-pages/node/appeal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node/appeal"])
      });
    }
  